"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.SEARCH_BOX_SELECTED = exports.PERSONAL_TOOLBAR_OPTIONS = exports.DC_SERVICE_API_KEYS = exports.SSO_THEMES = exports.BRANDS = void 0;
var BRANDS = {
  SHUTTERFLY: 'SFLY',
  TINYPRINTS: 'TP',
  INC: 'INC'
};
exports.BRANDS = BRANDS;
var SSO_THEMES = {
  SHUTTERFLY: 'SFLY',
  TINYPRINTS: 'TP',
  INC: 'INC',
  LTI: 'LTI',
  MLT: 'MLT',
  PRESCHOOLS: 'PRESCHOOLS',
  PRESTIGE: 'PRESTIGE'
};
exports.SSO_THEMES = SSO_THEMES;
var DC_SERVICE_API_KEYS = {
  PROD: 'RpZyUyLnS6YP1UVEccqGlU03FJHAujXF',
  NON_PROD: '06h8A9QTVBXAfEqYMCItB7nM2n2Q0r30'
};
exports.DC_SERVICE_API_KEYS = DC_SERVICE_API_KEYS;
var PERSONAL_TOOLBAR_OPTIONS = {
  SIGN_OUT: 'Sign out'
};
exports.PERSONAL_TOOLBAR_OPTIONS = PERSONAL_TOOLBAR_OPTIONS;
var SEARCH_BOX_SELECTED = 'search box selected';
exports.SEARCH_BOX_SELECTED = SEARCH_BOX_SELECTED;
var _default = {
  BRANDS: BRANDS,
  DC_SERVICE_API_KEYS: DC_SERVICE_API_KEYS,
  PERSONAL_TOOLBAR_OPTIONS: PERSONAL_TOOLBAR_OPTIONS
};
exports.default = _default;